// Returns an HTML string for a shimmering skeleton table that occupies the
// same rough shape as the eventual rendered table. Use when fetching list data
// so layout doesn't jump on first paint.

export function skeletonTable(opts: { rows?: number; columns?: number } = {}): string {
  const rows = opts.rows ?? 6;
  const cols = opts.columns ?? 5;
  const header = Array.from({ length: cols }, () => '<th><span class="skl-bar skl-bar-sm" style="width:60%"></span></th>').join('');
  const body = Array.from({ length: rows }, () => {
    const tds = Array.from({ length: cols }, () => '<td><span class="skl-bar"></span></td>').join('');
    return `<tr>${tds}</tr>`;
  }).join('');
  return `<table class="skl-table"><thead><tr>${header}</tr></thead><tbody>${body}</tbody></table>`;
}

export function skeletonLines(lines = 3): string {
  return Array.from({ length: lines }, () => '<div class="skl-bar" style="height:14px;margin:8px 0"></div>').join('');
}
